import React, { useEffect, useState } from 'react';
import { Breadcrumb, Card, CardBody, Col, Container, Nav, NavItem, NavLink, Row } from 'reactstrap';
import classnames from "classnames";
// import { RootState, useDashboardQuery } from "store";
import { useSelector } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';
import Indicator from './Indicator';
import BasinList from './BasinList';
import { useRiverFindAllQuery } from 'store';
import Detail from './Detail';
import { useJobDayQuery } from 'store/apis/core/jobDayApi';


const DashboardMain: React.FC = () => {
  const [customActiveTab, setcustomActiveTab] = useState("1");

  const [indicatorName, setIndicatorName] = useState("");
  const [logList, setlogList] = useState<any>([])

  const [logLakeInfo, setLogLakeInfo] = useState<any>([]);
  const [logLakeInfoDt, setLogLakeInfoDt] = useState<any>(null);
  const [updateLakeData, setUpdateLakeData] = useState<any>([]);
  const [createLakeData, setCreateLakeData] = useState<any>([]);

  const [logRiverInfo, setLogRiverInfo] = useState<any>([]);
  const [logRiverInfoDt, setLogRiverInfoDt] = useState<any>(null);
  const [updateRiverData, setUpdateRiverData] = useState<any>([]);
  const [createRiverData, setCreateRiverData] = useState<any>([]);


  const [logSpringInfo, setLogSpringInfo] = useState<any>([]);
  const [logSpringInfoDt, setLogSpringInfoDt] = useState<any>(null);
  const [updateSpringData, setUpdateSpringData] = useState<any>([]);
  const [createSpringData, setCreateSpringData] = useState<any>([]);


  const [logIceRiverInfo, setLogIceRiverInfo] = useState<any>([]);
  const [logIceRiverInfoDt, setLogIceRiverInfoDt] = useState<any>(null);
  const [updateIceRiverData, setUpdateIceRiverData] = useState<any>([]);
  const [createIceRiverData, setCreateIceRiverData] = useState<any>([]);

  const {
    data: logListData,
    error: logListDataError,
    isFetching: islogListDataFetching,
    refetch,
  } = useJobDayQuery();

  useEffect(() => {
    setlogList(logListData?.data)
    // console.log('logListData', logList?.rows)
  }, [logListData])

  function groupByChangeDate(logs) {
    return logs.reduce((acc, e) => {
      const dateString = e.date;
      const date = new Date(dateString);
      const formattedDate = date.toISOString().split('T')[0];
      if (!acc[formattedDate]) {
        acc[formattedDate] = { date: formattedDate, count: 0 };
      }
      acc[formattedDate].count += e.count || 0;
      return acc;
    }, {});
  }

  function sortedCounts(groupedLogs) {
    return groupedLogs
      .sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);

        // Check if dates are valid
        if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
          console.error('Invalid date:', a.date, b.date);
          return 0;  // Return 0 if there's an invalid date to avoid sorting errors
        }

        // Compare valid dates
        return dateA.getTime() - dateB.getTime();
      })
      .map((item) => item.count); // Return only the counts in sorted order
  }
  function sortedDate(groupedLogs) {
    return [
      ...new Set(
        groupedLogs
          .sort((a, b) => {
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);
            if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
              console.error('Invalid date:', a.date, b.date);
              return 0;  // Return 0 if there's an invalid date to avoid sorting errors
            }
            return dateA.getTime() - dateB.getTime(); // Sort dates in ascending order
          })
          .map((item) => new Date(item.date).toLocaleDateString('default', { day: '2-digit', month: '2-digit', year: 'numeric', })) // Extract only the date values
      ),
    ];
  }


  useEffect(() => {
    const rows = logList?.rows || [];
    console.log(logList?.rows)
    if (logList?.rows?.length > 0) {
      const logEditLake: any[] = [];
      const logCreateLake: any[] = [];
      const logLakeInterval: any[] = [];
      let logLakeCategory: any[] = [];

      const logEditRiver: any[] = [];
      const logCreateRiver: any[] = [];
      const logRiverInterval: any[] = [];
      let logRiverCategory: any[] = [];

      const logEditSpring: any[] = [];
      const logCreateSpring: any[] = [];
      const logSpringInterval: any[] = [];
      let logSpringCategory: any[] = [];

      const logEditIceRiver: any[] = [];
      const logCreateIceRiver: any[] = [];
      const logIceRiverInterval: any[] = [];
      let logIceRiverCategory: any[] = [];


      if (logList?.rows?.length > 0) {
        logList?.rows.forEach((e) => {
          if (typeof e.table_name === 'string' && e.table_name.includes('нуур тойром')) {
            const date = new Date(e.change_date).toISOString().split('T')[0];
            logEditLake.push({ date, count: e.updated_cnt || 0 });
            logCreateLake.push({ date, count: e.created_cnt || 0 });
          }
          if (typeof e.table_name === 'string' && e.table_name.includes('гол мөрөн')) {
            const date = new Date(e.change_date).toISOString().split('T')[0];
            logEditRiver.push({ date, count: e.updated_cnt || 0 });
            logCreateRiver.push({ date, count: e.created_cnt || 0 });
          }

          if (typeof e.table_name === 'string' && e.table_name.includes('булаг шанд')) {
            const date = new Date(e.change_date).toISOString().split('T')[0];
            logEditSpring.push({ date, count: e.updated_cnt || 0 });
            logCreateSpring.push({ date, count: e.created_cnt || 0 });
          }

          if (typeof e.table_name === 'string' && e.table_name.includes('мөсөн гол')) {
            const date = new Date(e.change_date).toISOString().split('T')[0];
            logEditIceRiver.push({ date, count: e.updated_cnt || 0 });
            logCreateIceRiver.push({ date, count: e.created_cnt || 0 });
          }
        });
      }
      // Lake
      const editLakeLogs = [...logEditLake];
      const createLakeLogs = [...logCreateLake];
      interface Log {
        date: string;
        count: number;
      }
      const groupedLakeEditLogs: Log[] = Object.values(groupByChangeDate(editLakeLogs));
      const groupedLakeCreateLogs: Log[] = Object.values(groupByChangeDate(createLakeLogs));

      const dateLabels = sortedDate(logEditLake)
      logLakeCategory = dateLabels;

      const sortedEditCounts = sortedCounts(groupedLakeEditLogs)
      const sortedCreateCounts = sortedCounts(groupedLakeCreateLogs)

      const editObj = { name: '' as string, data: null as number[] | null };
      updateLakeData.push(sortedEditCounts)
      editObj.data = updateLakeData
      editObj.name = 'Зассан'
      logLakeInterval.push(editObj)

      const createObj = { name: '' as string, data: null as number[] | null };
      createLakeData.push(sortedCreateCounts)
      createObj.data = createLakeData
      createObj.name = 'Нэмсэн'
      logLakeInterval.push(createObj)

      setLogLakeInfo(logLakeInterval);
      setLogLakeInfoDt(logLakeCategory);

      // River

      const editRiverLogs = [...logEditRiver];
      const createRiverLogs = [...logCreateRiver];
      interface Log {
        date: string;
        count: number;
      }
      const groupedRiverEditLogs: Log[] = Object.values(groupByChangeDate(editRiverLogs));
      const groupedRiverCreateLogs: Log[] = Object.values(groupByChangeDate(createRiverLogs));
      const dateRiverLabels = sortedDate(logEditRiver)

      logRiverCategory = dateRiverLabels;


      const sortedEditRiverCounts = sortedCounts(groupedRiverEditLogs)
      const sortedCreateRiverCounts = sortedCounts(groupedRiverCreateLogs)

      const editRiverObj = { name: '' as string, data: null as number[] | null };
      updateRiverData.push(sortedEditRiverCounts)
      editRiverObj.data = updateRiverData
      editRiverObj.name = 'Зассан'
      logRiverInterval.push(editRiverObj)

      const createRiverObj = { name: '' as string, data: null as number[] | null };
      createRiverData.push(sortedCreateRiverCounts)
      createRiverObj.data = createRiverData
      createRiverObj.name = 'Нэмсэн'
      logRiverInterval.push(createRiverObj)

      setLogRiverInfo(logRiverInterval);
      setLogRiverInfoDt(logRiverCategory);

      // Spring

      const editSpringLogs = [...logEditSpring];
      const createSpringLogs = [...logCreateSpring];
      interface Log {
        date: string;
        count: number;
      }
      const groupedSpringEditLogs: Log[] = Object.values(groupByChangeDate(editSpringLogs));
      const groupedSpringCreateLogs: Log[] = Object.values(groupByChangeDate(createSpringLogs));
      const dateSpringLabels = sortedDate(logEditSpring)
      logSpringCategory = dateSpringLabels;

      const sortedEditSpringCounts = sortedCounts(groupedSpringEditLogs)
      const sortedCreateSpringCounts = sortedCounts(groupedSpringCreateLogs)

      const editSpringObj = { name: '' as string, data: null as number[] | null };
      updateSpringData.push(sortedEditSpringCounts)
      editSpringObj.data = updateSpringData
      editSpringObj.name = 'Зассан'
      logSpringInterval.push(editSpringObj)

      const createSpringObj = { name: '' as string, data: null as number[] | null };
      createSpringData.push(sortedCreateSpringCounts)
      createSpringObj.data = createSpringData
      createSpringObj.name = 'Нэмсэн'
      logSpringInterval.push(createSpringObj)

      setLogSpringInfo(logSpringInterval);
      setLogSpringInfoDt(logSpringCategory);

      // IceRiver
      const editIceRiverLogs = [...logEditIceRiver];
      const createIceRiverLogs = [...logCreateIceRiver];
      interface Log {
        date: string;
        count: number;
      }
      const groupedIceRiverEditLogs: Log[] = Object.values(groupByChangeDate(editIceRiverLogs));
      const groupedIceRiverCreateLogs: Log[] = Object.values(groupByChangeDate(createIceRiverLogs));
      const dateIceRiverLabels = sortedDate(logEditIceRiver)
      logIceRiverCategory = dateIceRiverLabels;

      const sortedEditIceRiverCounts = sortedCounts(groupedIceRiverEditLogs)
      const sortedCreateIceRiverCounts = sortedCounts(groupedIceRiverCreateLogs)

      const editIceRiverObj = { name: '' as string, data: null as number[] | null };
      updateIceRiverData.push(sortedEditIceRiverCounts)
      editIceRiverObj.data = updateIceRiverData
      editIceRiverObj.name = 'Зассан'
      logIceRiverInterval.push(editIceRiverObj)

      const createIceRiverObj = { name: '' as string, data: null as number[] | null };
      createIceRiverData.push(sortedCreateIceRiverCounts)
      createIceRiverObj.data = createIceRiverData
      createIceRiverObj.name = 'Нэмсэн'
      logIceRiverInterval.push(createIceRiverObj)

      setLogIceRiverInfo(logIceRiverInterval);
      setLogIceRiverInfoDt(logIceRiverCategory);
    }
  }, [logList])

  return (
    <React.Fragment>
      <div className="page-content">
        <Breadcrumb title="Хянах самбар" breadcrumbItem="Хянах самбар" />
        <Container fluid>

          <Row className='position-relative'>
            {/* < Col lg={3} style={{ paddingTop: "50px" }}>
                  <BasinList />
                </Col> */}
            <Col className='position-relative'>
              <Row className='justify-content-end mb-3 '>
                <Col lg={3}>
                  {/* <Nav tabs className="nav-tabs-custom nav-justified">
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: customActiveTab === "1",
                            })}
                            onClick={() => {
                              toggleCustom("1");
                            }}
                          >
                            <span className="d-block d-sm-none">
                              <i className="fas fa-home"></i>
                            </span>
                            <span className="d-none d-sm-block fw-semibold">Сараар</span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: customActiveTab === "2",
                            })}
                            onClick={() => {
                              toggleCustom("2");
                            }}
                          >
                            <span className="d-block d-sm-none"><i className="far fa-user"></i></span>
                            <span className="d-none d-sm-block fw-semibold">Жилээр</span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: customActiveTab === "3",
                            })}
                            onClick={() => {
                              toggleCustom("3");
                            }}
                          >
                            <span className="d-block d-sm-none">
                              <i className="far fa-envelope"></i>
                            </span>
                            <span className="d-none d-sm-block fw-semibold">Нийт</span>
                          </NavLink>
                        </NavItem>
                      </Nav> */}
                </Col>
              </Row>
              <div>
                <Detail />
              </div>
              <Col lg={12}>
                <Row>
                  <Indicator
                    indicatorName={indicatorName}
                    logListInfo={logLakeInfo}
                    logListInfoDt={logLakeInfoDt}

                    logListRiverInfo={logRiverInfo}
                    logListRiverInfoDt={logRiverInfoDt}

                    logListSpringInfo={logSpringInfo}
                    logListSpringInfoDt={logSpringInfoDt}

                    logListIceRIverInfo={logIceRiverInfo}
                    logListIceRIverInfoDt={logIceRiverInfoDt}
                  />
                </Row>
              </Col>
            </Col>
          </Row>

        </Container>
      </div>
    </React.Fragment >
  );
}

export default DashboardMain;